import { useEffect } from "react";
import { useState } from "react";

export function useLocalStorage(key, initialValue, identificador) {
  const key_fmt = !!identificador ? `${identificador}_${key}` : key;

  const [inicializado, setInicializado] = useState(false);
  const [state, setState] = useState(initialValue);

  useEffect(() => {
    const valor = window.localStorage.getItem(key_fmt);

    let aux = !!valor?.length ? JSON.parse(valor) : initialValue;

    if (typeof (aux) == "object" && !Array.isArray(aux) && !!initialValue)
      aux = { ...initialValue, ...aux };

    setState(aux);
    setInicializado(true);
  }, []);

  const saveState = dados => window.localStorage.setItem(key_fmt, JSON.stringify(!!dados ? dados : state));
  const removeState = () => window.localStorage.removeItem(key_fmt);
  return [state, setState, saveState, inicializado, removeState];
}